var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1 4.5 22 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.8 5.6c.6.4.8 1.5 1 3S23 11 23 12s0 1.9-.2 3.4-.4 2.6-1 3c-.6.5-5.8.6-9.8.6s-9.2-.1-9.8-.6c-.6-.4-.8-1.5-1-3S1 13 1 12s0-1.9.2-3.4.4-2.6 1-3C2.8 5.1 8 5 12 5s9.2.1 9.8.6M16 12l-6-3.6v7.2z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;